import {
    Modal,
    ModalHeader,
    ModalBody,
    ModalFooter,
} from "reactstrap";
import API from "../../Network/API";
import { useDispatch, useSelector } from "react-redux";
import { Children, useEffect, useRef, useState } from "react";
import Agent from "../../Network/Agent";
import Select, { components } from 'react-select';

function AlarmTypeOption(props) {
    return (
        <components.Option {...props}>
            <input type="checkbox" checked={props.isSelected} readOnly tabIndex={-1} style={{ marginRight: 8, pointerEvents: 'none' }} />
            {props.label}
        </components.Option>
    );
}

function AlarmTypeValueContainer(props) {
    const selectedCount = props.getValue().length;
    const children = Children.toArray(props.children);
    if (selectedCount <= 2) {
        return <components.ValueContainer {...props}>{props.children}</components.ValueContainer>;
    }
    const extra = selectedCount - 2;
    return (
        <components.ValueContainer {...props}>
            {children.slice(0, 2)}
            <span style={{ fontSize: 12, marginLeft: 4, whiteSpace: 'nowrap' }}>{extra} more alarm type selected</span>
            {children[children.length - 1]}
        </components.ValueContainer>
    );
}

export default function FilterAcs({ filter_type, callbackSearch }) {

    const [loading, setLoading] = useState(false);
    const modalRef1 = useRef()
    const dispatch = useDispatch();
    const [modalDialogUlock, setModalDialogUlock] = useState(false);
    const [site_id, setSiteId] = useState('')
    const inputRef = useRef(null);
    const [resetKey, setResetKey] = useState(0);
    const [options, setOption] = useState([])
    const [options2, setOption2] = useState([])
    const [options3, setOption3] = useState([])
    const [zone_id, setZoneId] = useState('');
    const [alarm_type_id, setAlarmId] = useState('');
    const [cluster_id, setClusterId] = useState('');
    const selector_cluster = useSelector((state) => state.clusterReducer);
    const tenants = useSelector((state) => state.tenantReducer)
    const select_acs_alarm_master = useSelector((state) => state.lockAlarmListReducer)
    const [loading_export, setLoadingExport] = useState(false);

    const searchZone = (e) => {
        setOption2([])
        if (!e) {
            setClusterId('');
            setOption2([])
            return;
        }

        setClusterId(e?.value)
        // console.log("Cluster ID:", e.value);
        API.get(`/v1/oauth/ajax_cluster_zone/${e.value}`).then((response) => {
            setOption2(response.data.data.zone)
        }).catch((error) => {

        });
    }

    useEffect(() => {
        if (selector_cluster?.data && Array.isArray(selector_cluster.data)) {
            const newOptions = selector_cluster?.data?.map(item => ({
                value: item.id.toString(), // Assuming you want the ID as a string
                label: item.name
            }));
            setOption(newOptions);
        } else {
            setOption([]); // Optional: clear options if data is not available
        }
        // For alarm type

        if (select_acs_alarm_master?.data?.lock_alarms && Array.isArray(select_acs_alarm_master?.data?.lock_alarms)) {
            const alarmOptions = select_acs_alarm_master?.data?.lock_alarms?.map(item => ({
                value: item.order_list.toString(), // Assuming you want the ID as a string
                label: item.name
            }));
            setOption3(alarmOptions);
        } else {
            setOption3([]); // Optional: clear options if data is not available
        }
    }, [selector_cluster, select_acs_alarm_master]);

    const searchZoneSite = (e) => {

        if (!e) {
            setZoneId('');
            return;
        }
        setZoneId(e?.value)
    }

    const searchAlarmType = (e) => {

        if (!e) {
            setAlarmId('');
            return;
        }

        // For multi-select, you might want to extract values differently
        const selectedValues = e.map(item => item.value).join(',');
        //   console.log("Selected Alarm Types:", selectedValues);
        setAlarmId(selectedValues);
    }

    const unlockDoorButton = (value) => {
        setModalDialogUlock(!modalDialogUlock)
    }
    const delay = (ms) => new Promise((res) => setTimeout(res, ms));
    const array_data = useRef({
        'page': 1,
        'site_code': "",
        'site_id': "",
        'tenant_id': "",
        'cluster': "",
        'zone': "",
        'alarm_type': "",
        'start_date': "",
        'end_date': "",
        'filter_type': "",
        'query': "",
        'alarmIds': "",
        'export_type': 2,
        'loadMore': false,
    });


    const exportAcsActiveAlarm = async () => {
        setLoadingExport(true);
        try {

            array_data.current.export_type = 2
            let response;
            response = await Agent.ACS_ALARM.export_active_alarm(array_data.current);


            // Extract filename from Content-Disposition header or set a default
            const contentDisposition = response.headers['content-disposition'];
            let filename = 'acs_alarms.xlsx';

            if (contentDisposition) {
                const matches = /filename[^;=\n]*=(['"]?)([^'";\n]*)\1/.exec(contentDisposition);
                if (matches && matches[2]) {
                    filename = matches[2];
                }
            }

            const blob = new Blob([response.data]);
            const downloadLink = document.createElement('a');
            downloadLink.href = URL.createObjectURL(blob);
            downloadLink.download = filename;
            document.body.appendChild(downloadLink);
            downloadLink.click();
            document.body.removeChild(downloadLink);
            URL.revokeObjectURL(downloadLink.href);
        } catch (error) {
            console.error('Error exporting file:', error);
        } finally {
            setLoadingExport(false);
        }
    }

    const exportAcsAlarm = async () => {
        setLoadingExport(true);
        try {
            array_data.current.export_type = ''
            let response;
            // check validation for date range
            if (!array_data.current.start_date || !array_data.current.end_date) {
                alert("Please select start and end dates for the history export.");
                setLoadingExport(false);
                return;
            }

            response = await Agent.ACS_ALARM.export_active_alarm(array_data.current);


            // Extract filename from Content-Disposition header or set a default
            const contentDisposition = response.headers['content-disposition'];
            let filename = 'acs_alarms.xlsx';

            if (contentDisposition) {
                const matches = /filename[^;=\n]*=(['"]?)([^'";\n]*)\1/.exec(contentDisposition);
                if (matches && matches[2]) {
                    filename = matches[2];
                }
            }

            const blob = new Blob([response.data]);
            const downloadLink = document.createElement('a');
            downloadLink.href = URL.createObjectURL(blob);
            downloadLink.download = filename;
            document.body.appendChild(downloadLink);
            downloadLink.click();
            document.body.removeChild(downloadLink);
            URL.revokeObjectURL(downloadLink.href);
        } catch (error) {
            console.error('Error exporting file:', error);
        } finally {
            setLoadingExport(false);
        }
    }

    const exportAlarm = async () => {
        if (filter_type === 1) {
            await exportAcsActiveAlarm();
        } else {
            await exportAcsAlarm();
        }
    }


    const handleSubmit = async (event) => {
        event.preventDefault();
        setLoading(true)
       
        array_data.current.cluster = cluster_id;
        array_data.current.zone = zone_id;
        array_data.current.query = alarm_type_id;
        array_data.current.page = 1;
        array_data.current.loadMore = false;
        array_data.current.site_code = site_id;
        array_data.current.site_id = site_id;
        array_data.current.filter_type = filter_type;
        array_data.current.tenant_id = event.target.tenant.value;
        array_data.current.start_date = event.target.from_date.value;
        array_data.current.end_date = event.target.to_date.value;
         callbackSearch(array_data.current);
        if (filter_type === 1) {
            Agent.ACS_ALARM.acs_active_alarm(dispatch, array_data.current);
        } else {
            Agent.ACS_ALARM.lock_alarm_history(dispatch, array_data.current);
        }

        await delay(100);
        setLoading(false);
        setModalDialogUlock(!modalDialogUlock);

    }

    const searchSite = (site_id) => {
        setSiteId(site_id);
        
        array_data.current.site_code = site_id;
        array_data.current.site_id = site_id;
        array_data.current.page = 1;
        array_data.current.loadMore = false;
        callbackSearch(array_data.current);
        if (filter_type === 1) {
            Agent.ACS_ALARM.acs_active_alarm(dispatch, array_data.current);
        } else {
            Agent.ACS_ALARM.lock_alarm_history(dispatch, array_data.current);
        }
    }

    function clearFilter() {
        setSiteId('');
        setClusterId('');
        setZoneId('');
        setAlarmId('');
       
        setResetKey(prevKey => prevKey + 1); // Change key to reset Select components
        array_data.current = {
            'page': 1,
            'site_code': "",
            'site_id': "",
            'tenant_id': "",
            'cluster': "",
            'zone': "",
            'alarm_type': "",
            'start_date': "",
            'end_date': "",
            'filter_type': "",
            'query': "",
            'loadMore': false,
        };
        callbackSearch(array_data.current);
        if (filter_type === 1) {
            Agent.ACS_ALARM.acs_active_alarm(dispatch, array_data.current);
        } else {
            Agent.ACS_ALARM.lock_alarm_history(dispatch, array_data.current);
        }
    }

    const refreshPage = () => {
        array_data.current.page = 1;
        array_data.current.loadMore = false;
        if (filter_type === 1) {
            Agent.ACS_ALARM.acs_active_alarm(dispatch, array_data.current);
        } else {
            Agent.ACS_ALARM.lock_alarm_history(dispatch, array_data.current);
        }
    }

    return (
        <>

            <div class="input-group input-group-sm">
                <input ref={inputRef} onKeyUp={(e) => searchSite(e.target.value)} type="text" class="form-control" placeholder="search by site id...." defaultValue={site_id} />

                <button className="btn btn-sm btn-outline-secondary" onClick={() => setModalDialogUlock(!modalDialogUlock)} title="Filter">
                    <i className="fa-solid fa-filter me-1"></i>

                </button>
                <Modal
                    isOpen={modalDialogUlock}
                    size=""
                    toggle={() => setModalDialogUlock(!modalDialogUlock)}
                    className={'modal-dialog'} backdrop="static"
                    ref={modalRef1} >
                    <ModalHeader toggle={() => setModalDialogUlock(!modalDialogUlock)} id={'staticBackdropLabel'}>
                        ACS Filter Alarms
                    </ModalHeader>
                    <form onSubmit={handleSubmit}>
                        <ModalBody>
                            <div className="row">

                                <div className="form-group  mb-2 col-md-6">
                                    <label className="form-label fs-7">Cluster</label>
                                    <Select key={resetKey} onChange={searchZone} name="cluster" isClearable closeMenuOnSelect={true} options={options} />

                                </div>
                                <div className="form-group mb-2 col-md-6">
                                    <label className="form-label fs-7">Zone</label>
                                    <Select key={resetKey} onChange={searchZoneSite} name="zone" isClearable closeMenuOnSelect={true} options={options2} />

                                </div>
                                <div className="form-group mb-2 col-md-6">
                                    <label className="form-label fs-7">Alarm Type</label>
                                    <Select key={resetKey} onChange={searchAlarmType} name="alarm_type" isClearable closeMenuOnSelect={false} hideSelectedOptions={false} components={{ Option: AlarmTypeOption, ValueContainer: AlarmTypeValueContainer }} options={options3} isMulti />

                                </div>
                                <div className="form-group mb-2 col-md-6">
                                    <label className="form-label fs-7">Tenant</label>
                                    <select name="tenant" className='form-select form-select-sm'>
                                        <option value={``}>All Tenant</option>
                                        {tenants?.data?.length > 0 && tenants?.data?.map((tenant, indexI) => (
                                            <option value={tenant.id}>{tenant.name}</option>
                                        ))}
                                    </select>
                                </div>
                                <div className="form-group mb-2">
                                    <label className="form-label fs-7">Date</label>
                                    <div className="input-group input-group-sm">
                                        <input name="from_date" type="date" class="form-control" placeholder="" />
                                        <input name="to_date" type="date" class="form-control" placeholder="" />
                                    </div>

                                </div>
                            </div>
                        </ModalBody>
                        <ModalFooter>
                            <button type="button" className="btn btn-secondary" onClick={() => setModalDialogUlock(!modalDialogUlock)}>Close</button>
                            <button type="submit" className="btn btn-info text-white">
                                {loading ? (
                                    <>
                                        <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                                        Loading...
                                    </>
                                ) : (
                                    'Apply Filter'
                                )}
                            </button>
                        </ModalFooter>
                    </form>
                </Modal>
                <button className="btn btn-sm btn-outline-primary" title="Export" onClick={() => exportAlarm()}>
                    <i className="fa-solid fa-file-export me-1"></i> {loading_export ? (
                        <>
                            <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>

                        </>
                    ) : (
                        ''
                    )}
                </button>
                {/* //clear filter button */}
                <button className="btn btn-sm btn-outline-danger" title="Clear Filter" onClick={() => {
                    clearFilter();
                }}>
                    <i className="fa-solid fa-eraser me-1"></i>

                </button>
                {/* // refresh button */}
                <button className="btn btn-sm btn-outline-success" title="Refresh" onClick={() => {
                    refreshPage();
                }}>
                    <i className="fa-solid fa-arrows-rotate me-1"></i>
                </button>
            </div>

        </>
    );
}